module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/coins.7278f101.svg";